import { PlacesType, Tooltip } from 'react-tooltip'
import { randomCode } from '@base/lang'
import { useMemo } from 'react'
import { rpx } from '@/utils'

interface TooltipsProps {
  title: string
  content: string
  ckey?: string
  className?: string
  place?: PlacesType
  children?: React.ReactNode
}

export default function Tooltips(props: TooltipsProps) {
  const { title, content, ckey, className, place = 'top', children } = props

  const keyName = useMemo(
    () => `tooltips-${ckey || 'ckey'}-${randomCode(10)}`,
    [ckey]
  )
  const privateClassName = useMemo(
    () => (className ? `${className} ${keyName}` : keyName),
    [className, keyName]
  )

  return (
    <div className={privateClassName}>
      {children}
      <Tooltip
        anchorSelect={`.${keyName}`}
        place={place}
        style={{
          zIndex: '4',
          padding: rpx(10),
          maxWidth: rpx(384),
          background: 'rgba(0, 0, 0, 0.8)',
        }}
        positionStrategy="fixed"
        openEvents={{ click: true }}
      >
        <div className="prop-name">{title}</div>
        {content ? <div className="prop-desc">{content}</div> : null}
      </Tooltip>
    </div>
  )
}
